/**
 * Day grouping for a conversation.
 *
 * Everything here works in the reader's own timezone. Deriving the day by
 * slicing the ISO string would be UTC, so a message sent at 01:00 in Kampala
 * would file under the previous day's separator - visibly wrong to the person
 * who sent it.
 */

/** Stable per-day identity, used only to compare two messages. */
export function dayKey(iso: string, now: Date = new Date()): string {
  void now
  return new Date(iso).toLocaleDateString()
}

export function dayLabel(iso: string, now: Date = new Date()): string {
  const date = new Date(iso)
  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)

  if (date.toLocaleDateString() === now.toLocaleDateString()) return 'Today'
  if (date.toLocaleDateString() === yesterday.toLocaleDateString()) return 'Yesterday'

  return date.toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    // The year is noise until it differs from the one being read in.
    year: date.getFullYear() === now.getFullYear() ? undefined : 'numeric',
  })
}

export function clockTime(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })
}

/** True when this message opens a new day and should carry a separator. */
export function startsNewDay(iso: string, previousIso: string | undefined): boolean {
  return previousIso === undefined || dayKey(previousIso) !== dayKey(iso)
}
